import { Link } from "react-router";

import { styled } from "simplydo/react/styled";
import { mobileOnly, tabletUp } from "simplydo/react/theme";
import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

export const HomeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  position: relative;

  &[data-muted="true"] > *:not(:last-child) {
    opacity: 0.45;
  }
`;

export const HomeRowContainer = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns || 1}, 1fr);
  gap: 2rem;

  ${mobileOnly} {
    grid-template-columns: 1fr;
  }

  ${HomeRow} {
    &:before {
      content: "";
      position: absolute;
      bottom: -1rem;
      left: 0;
      width: 100%;
      height: 1px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.primary.softer};
    }

    ${tabletUp} {
      &:nth-last-child(-n + 2) {
        &:before {
          display: ${({ $columns }) => ($columns === 2 ? "none" : "block")};
        }
      }
    }

    &:nth-last-child(-n + 1) {
      &:before {
        display: none;
      }
    }
  }
`;

export const HomeRowIcon = styled.div<{ $contain?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $contain }) => ($contain ? "40px" : "50px")};
  height: 40px;
  border-radius: 8px;

  img {
    width: ${({ $contain }) => ($contain ? "40px" : "50px")};
    height: 40px;
    object-fit: ${({ $contain }) => ($contain ? "contain" : "cover")};
    border-radius: 8px;
  }

  &:has(${Icon}) {
    width: 40px;
    color: ${({ theme }) => theme.colors.primary.solid};
    background-color: ${({ theme }) => theme.colors.primary.softer};
  }
`;

export const HomeRowContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const HomeRowActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;

  ${Button} {
    margin: 0;
  }
`;

export const HomeLink = styled(Link)`
  && {
    color: ${({ theme }) => theme.colors.primary.solid};
  }
`;
